//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name:'Bicarbonate_deficiency',
  data() {
    return {
      defaultJson:{
        "Weight": "患者体重",
        "HCO₃": "HCO₃"
      },
      method:0,
      form:{
        weight:'',
        hco3:'',
      },
      contentDescription:'',
      hasScore:false,
      disabled:false,
      dataList1:[
        {value:0,name:'HCO₃'},
        {value:1,name:'PaCO₂'},
        {value:2,name:'pH'},
      ],
      res:'...',
      activeIndex:0,

    }
  },
  rqed () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
    exclusiveChild(item, index) {
      this.method = item.value;
      this.activeIndex = index
    }
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            if (form[key]=='---') {
              flag = false
            } else {
              form[key] = Number(form[key])
            }
          }
        }
      }
      console.log(form);
      if (!flag) {
        self.hasScore = false
        return '--'
      } else {
        // 缺乏量=0.4*体重*(24-HCO3)
        let result = 0.4 * form.weight * (24 - form.hco3)
        self.hasScore = true
        return String(result.toFixed(1))
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Endocrine/Bicarbonate_deficiency.vue